/**
 *
 * Asynchronously loads the component for OtherServiceDetailsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const OtherServiceDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.OtherServiceDetailsPage,
);
